module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAA2UlEQVRoQ+2YQRKEIAwE4dX6BH+NZ/UwhxDKCe3V7JJMN1Blb8cYbaOnM3Bx2hAuDrhBGMLFEkDpYkA/40AYwsUSQOliQDm0UBqliyWA0tlAx/VcoZ/ZK77WW/1Ni4EhnKv48kMLpVEapacmMH0Pv/dotNvZ9zQDR4lAOJjg75VW83EPcw8rR2Lvp5/Sqh2URmnlSOw9Ssfy07/ebg/rSHIrliudO47+dwbWGXlXQNibn+4ewjoj7woIe/PT3UNYZ+RdAWFvfrp7COuMvCsg7M1Pdw9hnZF3xQ3z87upDnGIyQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/addcompany.png
// module id = HGlw
// module chunks = 2